import React, { useEffect } from 'react'
import { Card, CardBody, CardFooter, CardHeader, Col } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import "./styles.css"
import { IJob } from '../../redux/types'
import { convertSectorName } from '../../utils/convertSectorName'
import useWindowSize from '../../utils/useWindowSize'
import { useTranslation } from 'react-i18next'
import { i18n } from 'i18next'//@ts-ignore
import noImage from "../../assets/noImg.png"
interface JobGroupProps {
    jobs: IJob[]
    sector: string
    i18n: i18n
}

export default function JobGroup(props: JobGroupProps) {

    const navigate = useNavigate()

    const [width, _] = useWindowSize()

    // const { i18n } = useTranslation()


    return (
        <div className='job-gorup'>
            {props.jobs.length > 0 && (
                <>
                    <h3 className='ms-3'>{convertSectorName(props.sector, props.i18n.language)}</h3>
                    <div className='card-col'  >
                        {props.jobs.map((job, index) => {
                            return (
                                <Card
                                    className='custom-card my-4 mx-3' key={index} onClick={() => navigate("/job-details/" + job._id)}
                                    style={{
                                        flex: width < 700 ? "0 0 15rem" : "0 0 20rem",
                                        width: width < 700 ? "15rem" : "20rem"
                                    }}
                                >
                                    <CardHeader style={{ maxHeight: "150px", minHeight: "150px", padding: 0, borderBottom: 0, display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                                        <img height={"100%"} style={{ objectFit: "cover", height: "100%", width: "100%", maxWidth: "150px", maxHeight: "150px" }} src={job?.img ? job.img : noImage} />
                                    </CardHeader>
                                    <CardBody className='custom-card-body'>
                                        <h4 style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{job.title}</h4>
                                        <h4 style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{job.firm}</h4>
                                    </CardBody>
                                    <CardFooter className='custom-card-footer'>

                                        <div style={{ textAlign: "start" }}>
                                            <p>• {" " + job.location}</p>
                                        </div>
                                    </CardFooter>
                                </Card>
                            )
                        })}
                    </div>
                </>
            )
            }

        </div >
    )
}
